import { render } from "./sub-footer-com.vue?vue&type=template&id=45dd1e02&scoped=true"
import script from "./sub-footer-com.vue?vue&type=script&lang=js"
export * from "./sub-footer-com.vue?vue&type=script&lang=js"

import "./sub-footer-com.vue?vue&type=style&index=0&id=45dd1e02&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dd1e02"]])

export default __exports__